const CART_RESERVATION_STORAGE_KEY = 'easyplants-cart-reservation-deadline';

function formatReservationTime(totalSeconds) {
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes}:${seconds.toString().padStart(2, '0')}`;
}

if (!customElements.get('cart-reservation-timer')) {
  class CartReservationTimer extends HTMLElement {
    connectedCallback() {
      this.duration = parseInt(this.dataset.duration, 10) || 1200;
      this.countdownEl = this.querySelector('.cart-reservation-timer__countdown');
      this.activeText = this.querySelector('.cart-reservation-timer__text--active');
      this.expiredText = this.querySelector('.cart-reservation-timer__text--expired');

      this.initDeadline();
      this.tick();

      clearInterval(this._interval);
      this._interval = setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      clearInterval(this._interval);
    }

    initDeadline() {
      const stored = sessionStorage.getItem(CART_RESERVATION_STORAGE_KEY);
      const now = Date.now();

      if (stored) {
        this.deadline = parseInt(stored, 10);
        return;
      }

      this.deadline = now + this.duration * 1000;
      sessionStorage.setItem(CART_RESERVATION_STORAGE_KEY, String(this.deadline));
    }

    tick() {
      const remainingSeconds = Math.max(0, Math.ceil((this.deadline - Date.now()) / 1000));

      if (remainingSeconds <= 0) {
        this.setExpired();
        clearInterval(this._interval);
        return;
      }

      if (this.countdownEl) {
        this.countdownEl.textContent = formatReservationTime(remainingSeconds);
      }
    }

    setExpired() {
      this.classList.add('is-expired');
      if (this.activeText) {
        this.activeText.hidden = true;
      }
      if (this.expiredText) {
        this.expiredText.hidden = false;
      }
    }
  }

  customElements.define('cart-reservation-timer', CartReservationTimer);
}

document.addEventListener('line-item:change:end', (event) => {
  if (event.detail?.cart?.item_count === 0) {
    sessionStorage.removeItem(CART_RESERVATION_STORAGE_KEY);
  }
});
